/**
 * Converts a number of seconds into a formatted string.
 * @param seconds The number of seconds.
 * @returns Seconds as a formatted string e.g. 2 hours 1 minute 34 seconds
 */
export function secondsToString(seconds: number) {

	const perMinute = 60;
	const perHour = perMinute * 60;
	let hours: number = 0;
	let minutes: number = 0;
	const str = [];

	if (seconds >= perHour) {

		hours = Math.floor(seconds / perHour);
		seconds = seconds % perHour;
	}

	if (seconds >= perMinute) {

		minutes = Math.floor(seconds / perMinute);
		seconds = seconds % perMinute;
	}

	if (hours > 0) {

		str.push([hours, hours > 1 ? "hours" : "hour"].join(' '));
	}

	if (minutes) {

		str.push([minutes, minutes > 1 ? "minutes" : "minute"].join(' '));
	}

	str.push([seconds, seconds !== 1 ? "seconds" : "second"].join(' '));

	return str.join(" ");
}